"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var EthereumErcTokenTransactionRequest_1 = require("./EthereumErcTokenTransactionRequest");
var EthereumErc20TransactionRequest = /** @class */ (function (_super) {
    tslib_1.__extends(EthereumErc20TransactionRequest, _super);
    function EthereumErc20TransactionRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return EthereumErc20TransactionRequest;
}(EthereumErcTokenTransactionRequest_1.EthereumErcTokenTransactionRequest));
exports.EthereumErc20TransactionRequest = EthereumErc20TransactionRequest;
//# sourceMappingURL=EthereumErc20TransactionRequest.js.map